export const URLS = {
  SEARCH: "/",
  INIT_STATION: "/station",
  BOX: "/box",
};
